/**
 * @generated SignedSource<<ca421b53344a880082a01ef55ae3298d>>
 * @relayHash 5e42aa4760fa1cda0f65d32ab2e48395
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraDeleteNavigationItemInput = {
  id: string;
};
export type servicesHideNavigationItemMutation$variables = {
  input: JiraDeleteNavigationItemInput;
};
export type servicesHideNavigationItemMutation$data = {
  readonly jira: {
    readonly deleteNavigationItem: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly navigationItem: string | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type servicesHideNavigationItemMutation = {
  response: servicesHideNavigationItemMutation$data;
  variables: servicesHideNavigationItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "navigationItem"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "servicesHideNavigationItemMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDeleteNavigationItemPayload",
            "kind": "LinkedField",
            "name": "deleteNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "servicesHideNavigationItemMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraDeleteNavigationItemPayload",
            "kind": "LinkedField",
            "name": "deleteNavigationItem",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf",
    "metadata": {},
    "name": "servicesHideNavigationItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4640fb5e180d56505dbc99767c68be10";

export default node;
